import { createTheme,  alpha } from '@mui/material/styles';

const defaultTheme = createTheme();


export const LightTheme = createTheme({
  palette: {

    primary: {
      main: "#343434",
      light: "#458ECD",
      dark: "#0B5593",
      lighter: "#f0f0f0",
    },
    secondary: {
      main: "#eeeeee",
      contrastText: "#424242"
    },
    success: {
      main: "#43766C",
      light: "#6E968E",
      dark: "#27443D",
      lighter: "#99B6B0",
    },
    error: {
      main: "#F24C3D",
      light: "#F57368",
      dark: "#862820",
      lighter: "#F89A93",
    }
  },
  shape: {
    borderRadius: 16
  },
  typography: {
    fontFamily: 'Onest',
    fontSize: 14,
    button: {
      textTransform: ""
    }
  },
  components: {
    // Button Customization
    MuiButton: {
      styleOverrides: {
        // Name of the slot
        root: {
          // Some CSS
          borderRadius: 50
        },
      },
      defaultProps: {
        disableElevation: true,
      },
      variants: [
        {
          props: { variant: 'contained', border: "true", color: "secondary" },
          style: {
            border: `1px solid ${defaultTheme.palette.grey[400]}`,
            // background: defaultTheme.palette.grey[200],
            // color: defaultTheme.palette.grey[800],
          },
        },
      ],
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          border: "1px solid gray !important",
          borderRadius: "8px",
          padding: "6px 14px",
          "&.Mui-selected": {
            backgroundColor: "#dbeeff",
            color: "#1e88e5",
            borderColor: "#1e88e5",
            "&:hover": {
              backgroundColor: "#dbeeff",
            },
          },
          "&:hover": {
            backgroundColor: "inherit",
          },
          "&.Mui-disabled": {
            backgroundColor: "#f5f5f5",
            color: "#9e9e9e",
          },
        },
      },
    },
    MuiPagination: {
      styleOverrides: {
        root: {
          padding: "10px",
        },
        ul: {
          justifyContent: "center",
          "& .MuiPaginationItem-root": {
            height: "40px",
            width: "40px",
            "&.Mui-selected": {
              backgroundColor: "#111",
              color: "#fff",
              "&:hover": {
                backgroundColor: "#111",
                color: "#fff",
              },
            },
            "&:hover": {
              backgroundColor: "inherit",
              color: "inherit",
            },
          },
          li: {
            ".MuiPaginationItem-root": {
              borderRadius: 7,
              border: "1px solid #0000003b",
              padding: "5px",
            },
          },
        },
      },
    },

    // Card Customization
    MuiCard: {
      styleOverrides: {
        root: {
          // borderRadius: 8,
          borderWidth: 1,
          borderColor: defaultTheme.palette.grey[200],
          borderStyle: "solid",
          "&.clickable": {
            boxShadow: "inset 0 0 0 0 transparent",
            transition: "box-shadow .1s ease",
            "&:hover": {
              boxShadow: "0 0 0px 2px #0F6CBD",
              cursor: "pointer"
            }
          },
        }
      },
      defaultProps: {
        disableElevation: true,
      }
    },
    MuiCardHeader: {
      styleOverrides: {
        // Name of the slot
        root: {
          // Some CSS
          borderBottomWidth: 1,
          borderBottomColor: defaultTheme.palette.grey[300],
          borderBottomStyle: "solid",
        },
        action: {
          alignSelf: "center"
        }


      },
      defaultProps: {
        sx: { py: 1 },
        titleTypographyProps: {
          variant: "body1",
          fontWeight: 600
        },
        subheaderTypographyProps: {
          variant: "body2",
        }
      },
    },

    // Circular Progress Customization
    MuiCircularProgress: {
      variants: [
        {
          props: { variant: 'indeterminate', use: "btnloader", size: "xsmall" },
          style: {
            height: 24,
            width: 24,
            color: "rgba(0, 0, 0, 0.26)"
          },
        },
      ],
    },

    MuiBackdrop: {
      styleOverrides: {
        root: {
          // background: "rgba(15, 20, 25, 0.25)",
          // backdropFilter: "blur(1.5px)",
          "&.MuiModal-backdrop": {
            background: "rgba(15, 20, 25, 0.25)",
            backdropFilter: "blur(1.5px)",
          },
          "&.MuiBackdrop-invisible": {
            background: "rgba(15, 20, 25, 0.0) !important",
            backdropFilter: "blur(0px) !important",
          }
        }
      }
    },

    // TextField Customization
    MuiFilledInput: {
      styleOverrides: {
        // Name of the slot
        root: {
          // Some CSS
          overflow: 'hidden',
          borderRadius: 10,
          backgroundColor: 'transparent',
          border: '1px solid',
          borderColor: defaultTheme.palette.mode === 'light' ? '#697786' : '#2D3843',
          transition: defaultTheme.transitions.create([
            'border-color',
            'background-color',
            'box-shadow',

          ]),
          "&:hover": {
            backgroundColor: defaultTheme.palette.mode === 'light' ? '#F3F6F9' : '#1A2027',
          },
          '&.Mui-focused': {
            backgroundColor: 'transparent',
            boxShadow: `${alpha(defaultTheme.palette.primary.main, 0.25)} 0 0 0 2px`,
            borderColor: defaultTheme.palette.primary.main,
            borderWidth: '2px',
            '&.Mui-error': {
              boxShadow: `${alpha(defaultTheme.palette.error.main, 0.25)} 0 0 0 2px`,
            },
          },
          '&.Mui-error': {
            borderColor: defaultTheme.palette.error.main,
          },
          '&.req': {
            borderRight: "2px solid red"
          }
        },

      },
      defaultProps: {
        disableUnderline: true,
      }
    },
    // Form Label asterisk Customization
    MuiFormLabel: {
      styleOverrides: {
        asterisk: { color: defaultTheme.palette.error.main },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          textDecoration: "none",
          "&:hover": {
            // borderBottom: "2px solid #0F6CBD"
            textDecoration: `underline ${defaultTheme.palette.primary.main} 2px`,
            textUnderlineOffset: 4
          },
        }
      }
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          padding: 8,
          '& .MuiSwitch-track': {
            borderRadius: 22 / 2,
            '&::before, &::after': {
              content: '""',
              position: 'absolute',
              top: '50%',
              transform: 'translateY(-50%)',
              width: 16,
              height: 16,
            },
            '&::before': {
              // backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
              //   defaultTheme.palette.getContrastText(defaultTheme.palette.primary.main),
              // )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
              left: 12,
            },
            '&::after': {
              // backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
              //   defaultTheme.palette.getContrastText(defaultTheme.palette.primary.main),
              // )}" d="M19,13H5V11H19V13Z" /></svg>')`,
              right: 12,
            },
          },
          '& .MuiSwitch-thumb': {
            boxShadow: 'none',
            width: 16,
            height: 16,
            margin: 2,
          },
        }
      }
    }
  },

});

